<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="source">Fuel Out</label>
                    <wj-combo-box
                        id="source"
                        name="source"
                        [(ngModel)]="target.source"
                        [itemsSource]="fuelOutMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="vehicle">Fuel In</label>
                    <wj-combo-box
                        id="vehicle"
                        name="vehicle"
                        [(ngModel)]="target.vehicle"
                        [itemsSource]="fuelInMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="jobId">Job</label>
                    <wj-combo-box
                        id="jobId"
                        name="jobId"
                        [(ngModel)]="target.jobId"
                        [itemsSource]="jobMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="date">Date</label>
                    <wj-input-date-time id="date" name="date" [(ngModel)]="target.date"></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="gallons">Gallons</label>
                    <input id="gallons" type="number" class="form-control" [(ngModel)]="target.gallons" name="gallons" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="meter">Meter</label>
                    <input id="meter" type="number" class="form-control" [(ngModel)]="target.meter" name="meter" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="lifetimeMeter">Lifetime Meter</label>
                    <input id="lifetimeMeter" type="number" class="form-control" [(ngModel)]="target.lifetimeMeter" name="lifetimeMeter" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
